import React, { useState } from "react";
import Item from "./Item";
import { faqItems } from "./data";

const defaultActive = faqItems[0].id;

function FAQ() {
  const [active, setActive] = useState(defaultActive);

  const toggleAccordion = id => {
    setActive(prev => (prev === id ? defaultActive : id));
  };

  return (
    <section className="bg-white py-12 sm:py-16 lg:py-20" id="faq">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h2 className="text-3xl font-bold text-gray-900 sm:text-4xl xl:text-5xl">
            Fundview FAQ – Everything You Need to Know
          </h2>
        </div>

        <div className="mx-auto mt-8 max-w-5xl sm:mt-14">
          <div className="space-y-4">
            {faqItems.map(item => (
              <Item key={item.id} item={item} active={active} toggleAccordion={toggleAccordion} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default FAQ;
